import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

function AreasLocalizacion() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [areas, setAreas] = useState([]);
    
    // Modal
    const [showModal, setShowModal] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [areaId, setAreaId] = useState(null);
    const [areaLocalizacion, setAreaLocalizacion] = useState('');
    const [descripcion, setDescripcion] = useState('');
    
    // Búsqueda
    const [busqueda, setBusqueda] = useState('');

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const tienePermiso = userdata.up && userdata.up.includes('gestionarAreasLocalizacion');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        cargarAreas();
    }, []);

    const cargarAreas = () => {
        axios.get('/areas-localizacion')
            .then(response => {
                if (response.status === 200) {
                    setAreas(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const abrirModalNuevo = () => {
        setModoEdicion(false);
        setAreaId(null);
        setAreaLocalizacion('');
        setDescripcion('');
        setShowModal(true);
    };

    const abrirModalEditar = (area) => {
        setModoEdicion(true);
        setAreaId(area.id);
        setAreaLocalizacion(area.area_localizacion);
        setDescripcion(area.descripcion || '');
        setShowModal(true);
    };

    const cerrarModal = () => {
        setShowModal(false);
        setModoEdicion(false);
        setAreaId(null);
        setAreaLocalizacion('');
        setDescripcion('');
    };

    const guardarArea = async () => {
        if (!areaLocalizacion.trim()) {
            alert('Por favor ingrese el nombre del área/localización');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`/area-localizacion/${areaId}`, {
                    area_localizacion: areaLocalizacion,
                    descripcion: descripcion
                });
                alert('Área/Localización actualizada exitosamente');
            } else {
                await axios.post('/area-localizacion', {
                    area_localizacion: areaLocalizacion,
                    descripcion: descripcion
                });
                alert('Área/Localización creada exitosamente');
            }
            
            cerrarModal();
            cargarAreas();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar: ' + (error.response?.data?.message || error.message));
        }
    };

    const eliminarArea = async (id, nombre) => {
        if (!window.confirm(`¿Está seguro de eliminar el área/localización "${nombre}"?`)) {
            return;
        }

        try {
            await axios.delete(`/area-localizacion/${id}`);
            alert('Área/Localización eliminada exitosamente');
            cargarAreas();
        } catch (error) {
            console.error('Error al eliminar:', error);
            alert('Error al eliminar: ' + (error.response?.data?.message || error.message));
        }
    };

    const areasFiltradas = areas.filter(area =>
        area.area_localizacion.toLowerCase().includes(busqueda.toLowerCase()) ||
        (area.descripcion && area.descripcion.toLowerCase().includes(busqueda.toLowerCase()))
    );

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item">Áreas/Localizaciones</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Áreas/Localizaciones</h1>
                                </div>
                                <div className="col-sm-4">
                                    <button 
                                        className="btn btn-primary float-right"
                                        onClick={abrirModalNuevo}
                                    >
                                        <i className="fas fa-plus"></i> Nueva Área/Localización
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            {/* Barra de búsqueda */}
                            <div className="card card-info card-outline">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group mb-0">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Buscar área/localización..."
                                                    value={busqueda}
                                                    onChange={(e) => setBusqueda(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Tabla de áreas */}
                            <div className="card card-info card-outline">
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table table-bordered table-hover" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th>Área/Localización</th>
                                                <th>Descripción</th>
                                                <th width="150">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {areasFiltradas.map((area, index) => (
                                                <tr key={area.id}>
                                                    <td>{index + 1}</td>
                                                    <td><strong>{area.area_localizacion}</strong></td>
                                                    <td>{area.descripcion || '-'}</td>
                                                    <td className="text-center">
                                                        <button 
                                                            className="btn btn-sm btn-primary mr-1"
                                                            onClick={() => abrirModalEditar(area)}
                                                            title="Editar"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => eliminarArea(area.id, area.area_localizacion)}
                                                            title="Eliminar"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {areasFiltradas.length === 0 && (
                                        <div className="text-center p-4">
                                            <p>No se encontraron áreas/localizaciones.</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal */}
                {showModal && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header bg-dark text-white">
                                    <h4 className="modal-title text-white">
                                        {modoEdicion ? 'Editar Área/Localización' : 'Nueva Área/Localización'}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={cerrarModal}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label>Área/Localización *</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Ej: Consultorio 1, Sala de Espera, Almacén..."
                                            value={areaLocalizacion}
                                            onChange={(e) => setAreaLocalizacion(e.target.value)}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Descripción</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            placeholder="Descripción opcional del área..."
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                                        Cancelar
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-primary" 
                                        onClick={guardarArea}
                                        disabled={!areaLocalizacion.trim()}
                                    >
                                        <i className="fas fa-save"></i> Guardar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} />
            </div>
        );
    }

    return <Loading />;
}

export default AreasLocalizacion;
